import SvgIcon from "@mui/material/SvgIcon";

export const CloseIcon = ({
  color = "var(--cc-primary)",
  sx,
  ariaLabel = "svg icon",
  onClick
}) => {
  return (
    <SvgIcon
      sx={{ fill: color, ...sx }}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.793 12.707a1 1 0 0 0 1.414-1.414L9.414 8.5l2.793-2.793a1 1 0 0 0-1.414-1.414L8 7.086 5.207 4.293a1 1 0 0 0-1.414 1.414L6.586 8.5l-2.793 2.793a1 1 0 1 0 1.414 1.414L8 9.914l2.793 2.793z" />
      </svg>
    </SvgIcon>
  );
};
